// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__IYB3j","label":"Section_label__1d4pX","contentWrap":"Section_contentWrap__3iClg","footer":"Section_footer__1OPnE","footerInner":"Section_footerInner__3WorT"};